'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function trimEnd(str, chars) {
    if (chars === undefined) {
        return str.trimEnd();
    }
    var endIndex = str.length;
    switch(typeof chars === "undefined" ? "undefined" : _type_of(chars)){
        case 'string':
            {
                if (chars.length !== 1) {
                    throw new Error("The 'chars' parameter should be a single character string.");
                }
                while(endIndex > 0 && str[endIndex - 1] === chars){
                    endIndex--;
                }
                break;
            }
        case 'object':
            {
                while(endIndex > 0 && chars.includes(str[endIndex - 1])){
                    endIndex--;
                }
            }
    }
    return str.substring(0, endIndex);
}
exports.trimEnd = trimEnd;
